import { render, staticRenderFns } from "./PosInvoicesTaxDetail.vue?vue&type=template&id=0476357b&scoped=true&"
import script from "./PosInvoicesTaxDetail.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTaxDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476357b",
  null
  
)

export default component.exports